import { DesignTokens } from "../../types"

export const baseFontSize = 16
export const getSize = (s: number) => `${Math.round(s * baseFontSize)}px`

export const sizes: DesignTokens.Sizes = {
  0: "0",
  1: getSize(0.0625),
  2: getSize(0.125),
  4: getSize(0.25),
  8: getSize(0.5),
  10: getSize(0.625),
  12: getSize(0.75),
  14: getSize(0.875),
  16: getSize(1),
  18: getSize(1.125),
  20: getSize(1.25),
  24: getSize(1.5),
  32: getSize(2),
  36: getSize(2.25),
  40: getSize(2.5),
  48: getSize(3),
  56: getSize(3.5),
  64: getSize(4),
}
